import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Label/Label.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "label";
var LABEL_CLASSNAME_MAP = {};
var Label = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      className,
      required,
      requiredLabel,
      htmlFor
    } = _b,
    rest = __objRest(_b, ["as", "children", "className", "required", "requiredLabel", "htmlFor"]);
  const Component = as || DEFAULT_COMPONENT;
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx(Component, __spreadProps(__spreadValues({
      ref,
      htmlFor,
      className: clsx("pd:label", className)
    }, rest), {
      children
    })), required && htmlFor && /* @__PURE__ */jsxs(Fragment, {
      children: [/* @__PURE__ */jsx("span", {
        className: "pd:field__required",
        "aria-hidden": "true",
        children: "*"
      }), /* @__PURE__ */jsx("span", {
        id: "".concat(htmlFor, "-required"),
        className: "pd:sr-only",
        children: requiredLabel
      })]
    })]
  });
});
var StoryLabel = args => /* @__PURE__ */jsx(Label, __spreadValues({}, args));
var Label_default = Label;
export { LABEL_CLASSNAME_MAP, StoryLabel, Label_default };